import React, { useState, useEffect } from 'react';
import { getLandInfo, getLandDocuments, downloadLandGPX, downloadAtlas } from '../services/api';

function InfoPanel({ apiUrl, selectedArea }) {
  const [areaInfo, setAreaInfo] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Загрузка информации об участке
  useEffect(() => {
    if (!selectedArea?.id) {
      setAreaInfo(null);
      setDocuments([]);
      return;
    }

    const loadAreaInfo = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const landData = await getLandInfo(selectedArea.id, apiUrl);
        if (landData) {
          setAreaInfo({
            name: landData.label || landData.land_name || 'Не указано',
            area: landData.land_area || landData.actual_area || landData.gis_area || null,
            description: landData.description || null,
            id: selectedArea.id
          });
        } else {
          setAreaInfo(null);
        }
        
        // Загружаем документы
        const docs = await getLandDocuments(selectedArea.id, apiUrl);
        setDocuments(docs);
      } catch (err) {
        console.error('Error loading area info:', err);
        setError(err.message || 'Ошибка загрузки данных');
        setAreaInfo(null);
        setDocuments([]);
      } finally {
        setLoading(false);
      }
    };

    loadAreaInfo();
  }, [selectedArea, apiUrl]);

  // Скачивание GPX
  const handleDownloadGPX = async () => {
    if (!selectedArea?.id) return;
    
    try {
      const landName = areaInfo?.name || selectedArea?.name || '';
      await downloadLandGPX(selectedArea.id, landName, apiUrl);
    } catch (err) {
      console.error('Error downloading GPX:', err);
      alert('Ошибка при скачивании GPX файла');
    }
  };

  // Скачивание документа (атлас или описание)
  const handleDownloadDocument = async (doc) => {
    if (!doc.path) return;
    
    try {
      const fileName = doc.doc_name || doc.path.split(/[/\\]/).pop();
      await downloadAtlas(doc.path, fileName, apiUrl);
    } catch (err) {
      console.error('Error downloading document:', err);
      alert('Ошибка при скачивании документа');
    }
  };

  if (!selectedArea) {
    return (
      <div className="info-panel">
        <h3>Информация об участке</h3>
        <p>Выберите участок на карте или через фильтры</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="info-panel">
        <h3>Информация об участке</h3>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="info-panel">
        <h3>Информация об участке</h3>
        <p className="error">Ошибка: {error}</p>
      </div>
    );
  }

  return (
    <div className="info-panel">
      <h3>Информация об участке</h3>
      
      {areaInfo && (
        <>
          <div className="info-item">
            <strong>Наименование:</strong>
            <span>{areaInfo.name}</span>
          </div>

          <div className="info-item">
            <strong>Площадь:</strong>
            <span>{areaInfo.area ? `${areaInfo.area} га` : 'Не указано'}</span>
          </div>

          {areaInfo.description && (
            <div className="info-item">
              <strong>Описание:</strong>
              <p>{areaInfo.description}</p>
            </div>
          )}

          {documents.length > 0 && (
            <div className="info-item">
              <strong>Документы (атлас и описание границ):</strong>
              <ul>
                {documents.map((doc, idx) => (
                  <li key={idx}>
                    <span>{doc.doc_name || 'Документ'}</span>
                    {doc.date_on && <span> ({doc.date_on})</span>}
                    {doc.path && (
                      <button 
                        onClick={() => handleDownloadDocument(doc)}
                        className="btn-download"
                        style={{ marginLeft: '10px', padding: '5px 10px', fontSize: '12px' }}
                      >
                        Скачать
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="info-actions">
            <button onClick={handleDownloadGPX} className="btn-download">
              Скачать GPX границу
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default InfoPanel;


